import { Component, OnInit } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { AuthenticationService } from "./core/services/auth.service";
import { LocalStorageService } from "./core/services/local-storage.service";
import { NGXLogger } from "ngx-logger";
import { ThemeService } from "./core/services/them.service";
import { PermissionEnum } from "./core/enum/permission";
import { CURRENT_USER, TOKEN } from "./core/const/constant";
import { filter, take } from "rxjs";
import { PwaInstallationService } from "./core/services/pwa-installation.service";
import { PushService } from "./core/services/push.service";

@Component({
	selector: "app-root",
	templateUrl: "./app.component.html",
})
export class AppComponent implements OnInit {
	protected isLightTheme = true;

	constructor(
		private authenticationService: AuthenticationService,
		private localStorageService: LocalStorageService,
		private logger: NGXLogger,
		private themeService: ThemeService,
		private router: Router,
		private pwaInstallationService: PwaInstallationService,
		private pushService: PushService,
	) {}

	ngOnInit() {
		this.initDataUser();
		this.pwaInstallationService.startTracking();
		this.pushService.start();
		this.themeService.initializedTheme();
		this.themeService.isLightTheme$.subscribe((isLight) => (this.isLightTheme = isLight));
	}

	initDataUser() {
		const user: any = JSON.parse(this.localStorageService.get(CURRENT_USER) || "{}");
		const token: any = this.localStorageService.get(TOKEN);

		if (user && user.id && token) {
			this.authenticationService.currentUserValue = user;
			this.authenticationService.currentUserSubject.next(user);
		} else {
			// Wait for router to initialize before checking URL
			this.router.events
				.pipe(
					filter((event) => event instanceof NavigationEnd),
					take(1),
				)
				.subscribe(() => {
					const currentUrl = this.router.url;
					const publicPaths = ["/auth/login", "/auth/register", "/auth/forgot-password","/auth/reset-password", "/auth/pass-create"];

					if (!publicPaths.some((path) => currentUrl.startsWith(path))) {
						this.router.navigate(["/auth/login"]);
					}
				});
		}
	}
}
